<template>
  <div class="thousand_layout" v-loading="loading">
    <div class="searchTop">
      <div class="watch_sort_status">
        <div>{{$t('enum.sortBy')}} :
          <el-select class="all_bids" v-model="Status" @change="getSelect">
            <el-option v-for="(item,index) in all_Sort_By" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="switchMode" :class="{'list':switchMode}" @click="switchMode=!switchMode"></div>
    </div>
    <div class="searchBody">
      <div class="searchBodyTitle">{{$t('base.emailAlerts')}}<span>({{searchPage.Email?searchPage.Email.length:0}}/{{searchCount}})</span></div>
      <div class="searchList" :class="{'list':switchMode}">
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="searchPage.emailTpye"/>
        <div class="slide_box" v-for="(item,index) in searchPage.Email" :key="index">
          <div class="silde_like" @click="goto(item)">
            <div class="like_box">
              <el-image class="like_img" :src="item.ImgUrl+'?imageView2/2/w/200'" fit="contain" lazy></el-image>
            </div>
            <div class="likeBody">
              <div class="">{{item.ShowKey}}</div>
              <p class="line_txt3">{{item.ShowValue}}</p>
            </div>
          </div>
          <div class="likeOperate">
            <span @click="delAlerts(item)">{{$t('base.Unsave')}}</span>
            <span @click="setAlerts(item)">{{$t('base.TurnOffEmailAlerts')}}</span>
          </div>
        </div>
      </div>
      <div class="searchBodyTitle noAlert">{{$t('base.noemailAlerts')}}</div>
      <div class="searchList noAlert" :class="{'list':switchMode}">
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="searchPage.noEmailTpye"/>
        <div class="slide_box " v-for="(item,index) in searchPage.NoEmail" :key="index">
          <div class="silde_like" @click="goto(item)">
            <div class="like_box">
              <el-image class="like_img" :src="item.ImgUrl+'?imageView2/2/w/200'" fit="contain" lazy></el-image>
            </div>
            <div class="likeBody">
              <div class="">{{item.ShowKey}}</div>
              <p class="line_txt3">{{item.ShowValue}}</p>
            </div>
          </div>
          <div class="likeOperate">
            <span @click="delAlerts(item)">{{$t('base.Unsave')}}</span>
            <span @click="setAlerts(item)">{{$t('base.TurnOnEmailAlerts')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { saveBrowseTime } from "@/api/public";
import NOTN from "@/components/notnull.vue";
export default {
  name: 'tabslist',
  components: { NOTN},
  data() {
    return {
      isBottom: false,
      searchCount: 0,
      loading: false,
      searchPage: {
        Email: [],
        NoEmail: [],
        emailTpye:false,
        noEmailTpye:false,
      },
      SortKey: 'ShowKey',
      switchMode: true,
      Status: 1,
      all_Sort_By: this.$enumInfo.search_Sort,
      pi: 1,
      ps: 60,
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getSetting()
    this.getSearchPage()
  },
  mounted() {
    let that = this
    window.addEventListener('scroll', function() {
      that.getScroll()
    })
  },
  methods: {
    getScroll() {
      let that = this
      const srcollY = window.scrollY;
      const windowHeight = window.innerHeight
      const scrollHeight = document.documentElement.scrollHeight
      const bottomHeight = windowHeight + srcollY >= scrollHeight
      if (bottomHeight) {
        if (!that.isBottom) {
          that.getSearchPage()
        }
      }
    },
    getSelect() {
      this.pi=1;
      if (this.Status == 1) {
        this.SortKey = 'FindKey'
      }
      if (this.Status == 2) {
        this.SortKey = 'CreateDate'
      }
      if (this.Status == 3) {
        this.SortKey = 'LastUpdateDate'
      }
      this.getSearchPage(true)
    },
    getSetting() {
      let that = this
      that.$get(that.$interface.SearchGetSetting, '').then(res => {
        if (res.Result != 0) {
          that.searchCount = res.Data.SearchCount
        }
      })
    },
    getSearchPage(remake) {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, SortKey: that.SortKey,PageIndex: that.pi, PageSize: that.ps }
      if (remake) {
        data.pi = 1
      } else {
        that.isBottom = true
      }
      that.loading = true
      that.searchPage.emailTpye=that.searchPage.emailTpye=false;
      that.$get(that.$interface.SearchPage, data).then(res => {
        if (res.Result != 0) {
          if (res.Data.length <= 0) {
            that.isBottom = true
          } else {
            that.pi += 1
            that.isBottom = false
          }
          let data = res.Data
          let yesNotice = []
          let noNotice = []
          data.map(item => {
            if (item.IsNotice) {
              yesNotice.push(item)
            } else {
              noNotice.push(item)
            }
          })
          //console.log(yesNotice,yesNotice.length,1111,that.pi == (1-1))
          // if(yesNotice.length<=0&&that.pi == (1-1)){
          //   console.log(yesNotice,yesNotice.length)
          //   that.searchPage.emailTpye=true
          // }
          // if(noNotice.length<=0&&that.pi == (1-1)){
          //   that.searchPage.noEmailTpye=true
          // }
          if (remake) {
            if (yesNotice.length > 0) {
              that.searchPage.Email = [...yesNotice]
            } else {
              that.searchPage.Email = null
            }
            if (noNotice.length > 0) {
              that.searchPage.NoEmail = [...noNotice]
            } else {
              that.searchPage.NoEmail = null
            }
          } else {
            if (yesNotice.length > 0) {
              that.searchPage.Email = [...yesNotice]
            }
            if (noNotice.length > 0) {
              that.searchPage.NoEmail = [...that.searchPage.NoEmail,...noNotice]
            }
          }
        } else {
          that.$message({
            type: 'error',
            duration: 2000,
            message: res.Msg
          });
        }
        that.loading = false
      })
    },
    setAlerts(obj) {
      let that = this;
      let emailNum = that.searchPage.Email ? that.searchPage.Email.length : 0
      if (!obj.IsNotice == true) {
        if (emailNum >= that.searchCount) {
          var html = "<div style='text-align: center;'>You can subscribe to email alerts for up to " + that.searchCount + " saved searches.(" + emailNum + "/" + that.searchCount + ")</div>"
          that.$confirm(html, that.$t('base.hint'), {
            dangerouslyUseHTMLString: true,
            lockScroll: false,
            showConfirmButton: false,
            cancelButtonText: that.$t('base.cancel'),
          }).then(() => {}).catch(() => {});
        } else {
          that.setNotice(obj)
        }
      } else {
        that.setNotice(obj)
      }

    },
    setNotice(obj) {
      let that = this;
      let data = { MemberId: that.userInfo.MappingUserId, Id: obj._id, Notice: !obj.IsNotice }
      that.loading = true
      that.$post(that.$interface.SetNotice, data).then(res => {
        if (res.Result != 0) {
          that.pi=1;
          that.getSetting()
          that.getSearchPage(true)
        } else {
          that.$message({
            type: 'error',
            duration: 2000,
            message: res.Msg
          });
        }
      })
    },
    delAlerts(obj) {
      let that = this;
      let data = { MemberId: that.userInfo.MappingUserId, Id: obj._id }
      that.loading = true
      that.$post(that.$interface.SearchDelete, data).then(res => {
        if (res.Result != 0) {
          that.pi=1
          that.getSetting()
          that.getSearchPage(true)
        } else {
          that.$message({
            type: 'error',
            duration: 2000,
            message: res.Msg
          });
        }
      })
    },
    goto(obj){
      let that=this
      saveBrowseTime(obj._id,that.userInfo.MappingUserId)
      let url={key:obj.FindKey,type:'search',id:obj._id}
      let data=JSON.parse(obj.FindValue)
      let fid=data.filter(res=>{
        return res.Key=='FirstCategoryId'
      })
      let sid=data.filter(res=>{
        return res.Key=='SecondCategoryId'
      })
      let tid=data.filter(res=>{
        return res.Key=='ThirdCategoryId'
      })
      url.f=fid.length>0?fid[0].Value:''
      url.s=sid.length>0?sid[0].Value:''
      url.t=tid.length>0?tid[0].Value:''
      window.localStorage.setItem("saveSearch",JSON.stringify(obj)) 
      that.$router.push({
        path:'/market',
        query:url
      }).catch(err=>{})
    }
  },
  //离开页面后清除
  destroyed() {
    let that = this;
    window.removeEventListener('scroll', function() {
      that.getScroll()
    })
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.notfind{
  height: 340px !important;
}
.el-button.abc {
  background-color: #fff;
  color: #333;
}

.thousand_layout {
  box-sizing: border-box;
  width: auto;
}

.searchTop {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.watch_sort_status {
  position: unset;
}

.watch_sort_status div {
  margin-left: 0;
}

.watch_sort_status .all_bids {
  width: 125px;
}

.switchMode {
  width: 24px;
  height: 24px;
  background: url(../../../static/images/switchModeBox.png) no-repeat;
  background-size: contain;
  cursor: pointer;
  margin-left: 24px;
}

.switchMode.list {
  background-image: url(../../../static/images/switchModeList.png);
}

.searchBodyTitle {
  position: relative;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;

}

.searchBodyTitle:before {
  content: '';
  width: 16px;
  height: 16px;
  background: url(../../../static/images/Message.png) no-repeat;
  background-size: contain;
  margin-right: 4px;
}

.searchBodyTitle.noAlert:before {
  background-image: url(../../../static/images/NoMessage.png);
}

.searchBodyTitle span {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
}

.searchList {
  display: grid;
  grid-template-columns: repeat(4, 228px);
  gap: 16px;
  margin: 16px 0 28px;
}

.slide_box {
  background-color: #f7f7f7;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.searchList.noAlert .slide_box {
  background-color: #fff;
}

.like_box {
  overflow: hidden;
  text-align: center;
}

.like_img {
  width: 222px;
  height: 222px;
  border-radius: 0;
  margin-top: 8px;
  background-color: #f7f7f7;
}

.likeBody {
  padding: 0 8px;
}

.likeBody>div {
  padding: 8px 0;
  font-size: 16px;
  font-weight: 700;
}

.likeBody>p {
  color: #a0a0a0;
}

.likeOperate {
  padding: 8px;
  display: flex;
  justify-content: space-between;
}

.likeOperate>span {
  cursor: pointer;
  color: #5f6dae;
}

.likeOperate>span:hover {
  text-decoration: underline;
}

.searchList.list {
  grid-template-columns: repeat(1, 100%);
}

.searchList.list .slide_box {
  display: flex;
  flex-direction: row;
}
.searchList .silde_like{
  cursor: pointer;
}
.searchList.list .silde_like {
  display: flex;
}

.searchList.list .like_img {
  width: 104px;
  height: 104px;
}

.searchList.list .likeBody {
  width: 693px;
}

.searchList.list .likeOperate {
  display: block;
  text-align: center;
  width: 200px;
}

.searchList.list .likeOperate>span {
  display: block;
  margin: 0 0 10px;

}

.searchList.list .like_img {
  margin-top: 4px;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/search.vue